var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('validation-observer', {
    ref: "observerRef"
  }, [_c('div', {
    staticClass: "p-1"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l(_vm.itemsConverted, function (item, index) {
    return _vm.items.length > 0 && !item.hide ? _c('div', {
      class: item.wrapperClass || _vm.defaultWrapperClass
    }, [_c('FormItem', _vm._b({
      attrs: {
        "value": _vm.formData[item.name]
      },
      on: {
        "input": function (v) {
          return _vm.updateFormData(item.name, v);
        }
      }
    }, 'FormItem', item, false))], 1) : _vm._e();
  }), 0)])]);
}
var staticRenderFns = []

export { render, staticRenderFns }